import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCliente } from "../../store/actions/clientes";

import { clientesTable } from "../../lib/tables/clientesTable";
import { Lista } from "../../components/Lista";

export const ListaClientes = () => {
  const clientes = useSelector((state) => state.clientes.clientes);

  const dispatch = useDispatch();

  const onUpdate = (id) => {
    dispatch(getCliente(id));
  };

  return (
    <Lista
      module="clientes"
      docs={clientes}
      onUpdate={onUpdate}
      listaModel={clientesTable()}
    />
  );

  // return (
  //   <TableContainer component={Paper}>
  //     <Table size="small" className={classes.table}>
  //       <TableHead>
  //         <TableRow>
  //           <PaginationM module="clientes" />
  //         </TableRow>
  //         <TableRow>
  //           <TableCell>Nombre</TableCell>
  //           <TableCell>RFC</TableCell>
  //           <TableCell>Notas</TableCell>
  //           <TableCell className={classes.tableCell}>
  //             <IconButton size="small">
  //               <BuildIcon style={{ fontSize: 16 }} />
  //             </IconButton>
  //           </TableCell>
  //         </TableRow>
  //       </TableHead>
  //       <TableBody>
  //         {clientes.map((doc) => (
  //           <StyledTableRow key={doc.id} hover className={classes.hover}>
  //             <TableCell className={classes.tableCell}>
  //               {doc.nombre}
  //             </TableCell>
  //             <TableCell className={classes.tableCell}>
  //               {doc.rfc}
  //             </TableCell>
  //             <TableCell className={classes.tableCell}>
  //               {doc.notas}
  //             </TableCell>
  //             <TableCell className={classes.tableCell}>
  //               <IconButton size="small" onClick={() => onUpdate(doc.id)}>
  //                 <BuildIcon style={{ fontSize: 16 }} />
  //               </IconButton>
  //             </TableCell>
  //           </StyledTableRow>
  //         ))}
  //       </TableBody>
  //       <TableFooter></TableFooter>
  //     </Table>
  //   </TableContainer>
  // );
};
